<template>
  <v-select
    class="select-box"
    :options="options"
    :label="label"
    :closeOnSelect="true"
    v-model="input"
    :multiple="multiple"
    :searchable="searchable"
    :loading="loading"
    @search="search"
    :reduce="(option) => (select ? option[select] : option)"
    :placeholder="placeHolder"
    :disabled="disabled"
  >
    <template #spinner="{ loading }">
      <b-spinner
        v-if="loading"
        variant="primary"
        label="Spinning"
        style="width: 1.5rem; height: 1.5rem"
      ></b-spinner>
    </template>

    <template #no-options> Please search your broker name! </template>
  </v-select>
</template>

<script>
import vSelect from "vue-select";
import { BSpinner } from "bootstrap-vue";
import qs from "qs";
export default {
  components: {
    vSelect,
    BSpinner,
  },
  props: {
    loader: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    select: {
      type: String,
      default: "",
    },
    option: {
      type: String,
      default: "",
    },
    lists: {
      type: Array,
      default: () => [],
    },
    url: {
      type: String,
      default: "",
    },
    value: {
      type: null,
    },
    placeHolder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      options: [],
      loading: false,
      query: { query: "" },
    };
  },

  methods: {
    debounceEvent(callback, keyword, time) {
      clearTimeout(this.interval);
      this.interval = setTimeout(() => {
        this.interval = null;
        callback(keyword);
      }, time);
    },
    async search(val) {
      this.debounceEvent(this.getOptionsOnSearch, val, 1000);
    },
    async getOptionsOnSearch(search) {
      this.loading = true;
      this.query.query = search;
      this.options = await [];
      try {
        const { data } = await this.$http.get(`/panel/${this.url}`, {
          params: this.query,
          paramsSerializer: (params) => {
            return qs.stringify(this.query);
          },
        });
        data.data.map((item) => {
          this.options.push(...item.results);
        });
      } catch (err) {}
      this.loading = false;
    },
  },
  computed: {
    input: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$nextTick(() => this.$emit("validate"));
      },
    },
  },
};
</script>
